import { useMutation, useQuery, useQueryClient } from "react-query";
import api from "../api";
import { API_ROUTES } from "../../utils/const";
import { createLink } from "../../pages/PaymentLinks/linksAPI";
import { invalidateNotificationsQueries } from "./notifications";

const FETCH_CUSTOMER_PAYMENT_LINKS = async (
  businessId: number,
  page: number,
  pageLimit: number,
) => {
  const response = await api.get(
    `${API_ROUTES.GET_CUSTOMER_PAYMENT_LINKS}/${businessId}?page=${
      page - 1
    }&size=${pageLimit}`,
  );
  return response?.data;
};

export const getCustomerPaymentLink = (
  businessId: number,
  page: number,
  pageLimit: number,
) => {
  return useQuery({
    queryKey: ["customerPaymentLinks", businessId, page, pageLimit],
    queryFn: () => FETCH_CUSTOMER_PAYMENT_LINKS(businessId, page, pageLimit),
    enabled: !!businessId,
  });
};

const DELETE_CUSTOMER_PAYMENT_LINK = async (id: number) => {
  return await api.get(`${API_ROUTES.DELETE_CUSTOMER_PAYMENT_LINK}/${id}`);
};

export const deleteCustomerPaymentLink = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: DELETE_CUSTOMER_PAYMENT_LINK,
    onSuccess: () => {
      queryClient.invalidateQueries(["customerPaymentLinks"]);
      invalidateNotificationsQueries(queryClient);
    },
  });
};

const CREATE_CUSTOMER_PAYMENT_LINK = async (payload: Parameters<
  typeof createLink
>[0]) => {
  return createLink(payload);
};

export const createCustomerPaymentLink = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: CREATE_CUSTOMER_PAYMENT_LINK,
    onSuccess: () => {
      queryClient.invalidateQueries(["customerPaymentLinks"]);
      invalidateNotificationsQueries(queryClient);
    },
  });
};

const SHARE_CUSTOMER_LINK = async ({
  message,
  link,
  sendType,
  sendValue,
  businessName,
}) => {
  return await api.post(API_ROUTES.SHARE_CUSTOMER_LINK, {
    message,
    link,
    [sendType]: sendValue,
    businessName,
  });
};

export const shareCustomerPaymentLink = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: SHARE_CUSTOMER_LINK,
    onSuccess: () => {
      invalidateNotificationsQueries(queryClient);
    },
  });
};
